import { IFormBuilder } from '../IFormBuilder';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';
import { RegisteredAddressControls, RegisteredAddressFormGroup } from '../RegisteredAddressFormGroup';
import { IRegisteredAddress } from '../../registered-address.model';
import { User } from '../../user.model';

interface IRegisteredAddressFormBuilder extends IFormBuilder<RegisteredAddressControls> {
  init(registeredAddress?: IRegisteredAddress): IRegisteredAddressFormBuilder;

  build(): RegisteredAddressFormGroup;
}

export class RegisteredAddressFormBuilder implements IRegisteredAddressFormBuilder {
  private formName = 'registeredAddressForm';
  private controls?: RegisteredAddressControls;
  private user!: User;

  constructor(private bcf: BaryFormFactoryService) {}

  init(user: User, registeredAddress?: IRegisteredAddress): IRegisteredAddressFormBuilder {
    this.controls = this.bcf.makeRegisteredAddressControls(registeredAddress);
    this.user = user;
    return this;
  }

  build(): RegisteredAddressFormGroup {
    return new RegisteredAddressFormGroup(this.formName, this.controls!, this.user);
  }
}
